import { Typography } from "@mui/material";
import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from "react";
import dayjs from "dayjs";

// Props do componente
interface IntervalProps {
  onTimeout: () => void;
}

// Ref exposta
export interface IntervalRef {
  startCounter: () => void;
}

const Interval: ForwardRefRenderFunction<IntervalRef, IntervalProps> = (
  { onTimeout },
  ref
) => {
  const [endTime, setEndTime] = useState<dayjs.Dayjs | null>(null);
  const [secondsLeft, setSecondsLeft] = useState<number>(0);

  // Atualiza o contador com base no tempo atual
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const tick = () => {
      if (!endTime) return;

      const now = dayjs();
      const diff = endTime.diff(now, "second");

      if (diff <= 0) {
        setSecondsLeft(0);
        onTimeout();
      } else {
        setSecondsLeft(diff);
        timeoutId = setTimeout(tick, 1000);
      }
    };

    if (endTime) {
      tick();
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [endTime, onTimeout]);

  // Método para iniciar o contador
  function start() {
    const newEndTime = dayjs().add(60, "second");
    setEndTime(newEndTime);
    setSecondsLeft(60);
  }

  useImperativeHandle(ref, () => ({
    startCounter: () => {
      start();
    },
  }));

  // Inicia o contador ao montar o componente
  useEffect(() => {
    start();
  }, []);

  // Renderização
  if (secondsLeft > 0) {
    return (
      <Typography>
        Para enviar novamente aguarde {secondsLeft} segundo(s)
      </Typography>
    );
  }

  return null;
};

export default forwardRef(Interval);
